define('TescoMobile_Checkout/js/model/quote-mixin',['ko', 'mage/utils/wrapper'], function (ko, wrapper) {
  'use strict';

  const quoteData = window.checkoutConfig.quoteData;
  const previousAddress = ko.observable(null);
  const mixin = {
    firstName: '',
    previousAddress: previousAddress,
    getData: function (key) {
      return quoteData[key];
    },
    getQuoteType: function () {
      var _quoteData$extension_;
      return (_quoteData$extension_ = quoteData.extension_attributes) === null || _quoteData$extension_ === void 0 ? void 0 : _quoteData$extension_.tm_quote_type;
    }
  };
  return function (target) {
    return wrapper.extend(target, mixin);
  };
});

